import { useParams } from 'react-router-dom';
import { Accordion } from 'react-bootstrap';
import { AppRemixIcon } from '@/layout/AppComponents';
import routes from './moduleQseRoutes';
import Sidebar from '../../../layout/Sidebar/Sidebar';
import SidebarButton from '../../../layout/Sidebar/SidebarButton';
import AppLink from '../../../routing/helpers/AppLink';

const ModuleQseSideBarReports = (props) => {
  const { moduleData } = props;
  const { moduleBridgeHex, subModuleBridgeHex, plantHex } = useParams();
  const { activeRoute } = props;

  return (
    <Sidebar>
      <Accordion>
        <ul>
          {routes.map((r, index) => {
            return (
              Object.keys(moduleData.indicators).includes(r.type) && (
                <li
                  key={index}
                  className={`${activeRoute === r.routeName ? 'active' : ''}`}
                >
                  <AppLink
                    path={r.routeName}
                    params={{
                      moduleBridgeHex: moduleBridgeHex,
                      subModuleBridgeHex: subModuleBridgeHex,
                      plantHex: plantHex,
                    }}
                    className="p-0"
                  >
                    <span className="sidebar-element" title={r.title}>
                      {r.icon && (
                        <AppRemixIcon icon={r.icon} className="sidebar-icon" />
                      )}
                      <span className="sb-title">{r.title}</span>
                    </span>
                  </AppLink>
                </li>
              )
            );
          })}
        </ul>
      </Accordion>
    </Sidebar>
  );
};

export default ModuleQseSideBarReports;
